// extracted by mini-css-extract-plugin
module.exports = {"root":"FaceToFaceDiscussionAttribute_root__lap9Y","attribute":"FaceToFaceDiscussionAttribute_attribute__iud0M"};